






























import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { OdpInfo, Medicine } from '../../models/odpModels';
import MedicineInformation from './MedicineInformation.vue';
import { MedicineInfo } from './MedicineInformation.vue';
import UsageSummary from './UsageSummary.vue';
import {
    IState,
    ImageMarkType,
    IUpdateOdpInfoPayload,
    FetchResult,
} from '../../store';
import { colors } from '../../styles/constants';
import { getIsDefaultEmphasize } from '../../services/UserSettingService';

interface UsageSummaryInfo {
    preparationDate: Date;
    takingTime: string;
    totalAmount: string;
}

@Component({
    components: {
        MedicineInformation,
        UsageSummary,
    },
})
export default class OdpInfomationComponent extends Vue {
    private isEmphasized = false;
    private emphasizedMessage = '刻印強調しています';
    private isOdpUnread = !this.odpReadState;

    private created() {
        // 薬情報が読込まれていないのであれば読取り画面に遷移させる。
        if (this.isOdpUnread) {
            this.$router.push({ path: '/OdpReader' });
        }
    }

    private beforeMount() {
        if (this.state.currentSettings.isEmphasized === undefined) {
            this.isEmphasized = getIsDefaultEmphasize();
            this.$store.commit('updateCurrentIsEmphasized', this.isEmphasized);
        } else {
            this.isEmphasized = this.state.currentSettings.isEmphasized;
        }
    }

    private shouldLoadImages(): boolean {
        const images =
            this.getImageMarkType() === ImageMarkType.Normal
                ? this.state.medicineImages.normal
                : this.state.medicineImages.emphasized;
        return this.state.medicines.length > 0 && !Object.keys(images).length;
    }

    private get state(): IState {
        return this.$store.state;
    }

    private get medicineInfos(): MedicineInfo[] {
        const medicines: Medicine[] = this.state.medicines;
        if (!medicines) {
            return [];
        }

        const MaxImageWidth = 50;
        const result = medicines.map((m) => {
            const medicineImage = this.$store.getters.getMedicineImage(
                this.getImageMarkType(),
                m,
            );
            const medicineInfo: MedicineInfo = {
                medicineName: m.name,
                medicinePhoneticName: m.phoneticName,
                doseAmount: m.doseAmount,
                doseUnit: m.doseUnit,
                imagePath: medicineImage ? medicineImage.path : null,
                imageWidth: medicineImage
                    ? medicineImage.sizeRatio * MaxImageWidth
                    : 0,
                imageHeight: medicineImage
                    ? medicineImage.sizeRatio * MaxImageWidth
                    : 0,
            };
            return medicineInfo;
        });

        return result;
    }

    private get usageSummary(): UsageSummaryInfo {
        const totalAmount = this.state.medicines
            .reduce((a: number, x: Medicine) => (a += x.doseAmount), 0)
            .toString();
        return {
            preparationDate: this.state.preparationDate,
            takingTime: this.state.takingTime,
            totalAmount,
        };
    }

    private get odpReadState(): boolean {
        return this.$store.state.fetchResult === FetchResult.Success;
    }

    private get iconColor() {
        return colors.ffGreen;
    }

    private get isImageLoadCompleted() {
        return (
            (!this.isEmphasized &&
                this.state.isAllNormalMedicineLoadCompleted) ||
            (this.isEmphasized &&
                this.state.isAllEmphasizedMedicineLoadCompleted)
        );
    }

    private changeMark() {
        this.$store.commit('updateCurrentIsEmphasized', this.isEmphasized);
    }

    private getImageMarkType() {
        return this.isEmphasized
            ? ImageMarkType.Emphasized
            : ImageMarkType.Normal;
    }
}
